import './styles/bcq-ui.css'
import './styles/ripple.css'
import './styles/tooltip.css'
import './styles/transitions.css'
import * as components from './components'

function BcqUi (Vue) {
  const BcqUi = components.BcqUi
  Vue.use(BcqUi, {
    components
  })
}

export default BcqUi



// WEBPACK FOOTER //
// ./src/bcq-ui/index.js